export default __webpack_public_path__ + "static/media/numberofdemandpartners.2aa9e335.svg";